import dayjs from "dayjs";

export default function doCoveringLogicWithElement(ElementUI) {
  const coverDatePicker = (DatePicker) => {
    const noCheckSet = new Set(["date", "month", "week", "year"]);
    const { handleStartChange, handleChange, handleEndChange } =
      DatePicker.mixins[0].methods;
    const allowMaxRangeDict = {
      daterange: {
        type: "date",
        max: 91,
        cn: "天",
        unit: "d",
      },
      week: {
        type: "week",
        max: 6,
        cn: "周",
        unit: "w",
      },
      monthrange: {
        type: "month",
        max: 3,
        cn: "月",
        unit: "M",
      },
      year: {
        type: "year",
        max: 1,
        cn: "年",
        unit: "year",
      },
    };
    const overTip = function () {
      if (typeof this.maxRangeTip === "undefined") {
        this.openMessage(
          0,
          `手工输入日期不可超过${
            this.maxRangeTime || allowMaxRangeDict[this.type].max
          }${allowMaxRangeDict[this.type].cn}`
        );
      } else if (
        typeof this.maxRangeTip === "string" &&
        this.maxRangeTip.length > 0
      ) {
        this.openMessage(0, this.maxRangeTip);
      }
      this.$emit("over-max-range", this);
    };
    /**
     * 校验日期
     * @param {string} type start | end | undefined
     * @param {Date[]} value
     */
    const checkDate = function (type, value) {
      let { displayValue, maxRangeTime, type: dateType } = this;
      if (noCheckSet.has(dateType)) return true;
      let result = true; // true 通过验证或跳过验证 false 验证失败
      const [start, end] = (() => {
        let result = [];
        if (type === "start") {
          result = [displayValue[0], displayValue[1]];
        } else if (type === "end") {
          result = [displayValue[0], displayValue[1]];
        } else if (type === undefined) {
          result = value;
        }
        return result;
      })();
      if (typeof maxRangeTime === "undefined") {
        maxRangeTime = allowMaxRangeDict[dateType].max;
      }
      if (typeof maxRangeTime === "undefined") {
        result = true;
        return result;
      }
      if (!dayjs(start).isValid() || !dayjs(end).isValid()) {
        result = true;
        return result;
      }
      if (
        Math.abs(dayjs(end).diff(start, allowMaxRangeDict[dateType].unit)) >
        maxRangeTime
      ) {
        result = false;
        return false;
      }
      return true;
    };
    // 失焦是这里
    DatePicker.mixins[0].methods.handleStartChange = function () {
      if (noCheckSet.has(this.type)) return handleStartChange.call(this);
      const value = this.parseString(this.userInput && this.userInput[0]);
      const checkDateResult = checkDate.call(this, "start");
      if (value) {
        if (!checkDateResult) {
          overTip.call(this);
          return;
        }
        this.userInput = [this.formatToString(value), this.displayValue[1]];
        const newValue = [value, this.picker.value && this.picker.value[1]];
        this.picker.value = newValue;
        if (this.isValidValue(newValue)) {
          this.emitInput(newValue);
          this.userInput = null;
        }
      }
    };
    DatePicker.mixins[0].methods.handleEndChange = function () {
      if (noCheckSet.has(this.type)) return handleEndChange.call(this);
      const value = this.parseString(this.userInput && this.userInput[1]);
      const checkDateResult = checkDate.call(this, "end");
      if (value) {
        if (!checkDateResult) {
          overTip.call(this);
          return;
        }
        this.userInput = [this.displayValue[0], this.formatToString(value)];
        const newValue = [this.picker.value && this.picker.value[0], value];
        this.picker.value = newValue;
        if (this.isValidValue(newValue)) {
          this.emitInput(newValue);
          this.userInput = null;
        }
      }
    };

    /** @description 回车走的是这里 */
    DatePicker.mixins[0].methods.handleChange = function () {
      if (noCheckSet.has(this.type)) return handleChange.call(this);
      if (this.userInput) {
        const value = this.parseString(this.displayValue);
        const checkDateResult = checkDate.call(this, undefined, value);
        if (!checkDateResult) {
          overTip.call(this);
          return;
        }
        if (value && checkDateResult) {
          this.picker.value = value;
          if (this.isValidValue(value)) {
            this.emitInput(value);
            this.userInput = null;
          }
        }
      }
      if (this.userInput === "") {
        this.emitInput(null);
        this.emitChange(null);
        this.userInput = null;
      }
    };
    /** @param {Number} 手动输入的最大区间 */
    DatePicker.props.maxRangeTime = {
      type: Number,
      require: false,
      default: undefined,
    };

    /** @param {String} 提示文案 */
    DatePicker.props.maxRangeTip = {
      type: String,
      require: false,
      default: undefined,
    };
  };
  const coverSelect = (Select) => {
    if (!Select) return
    const oldComputedReadOnly = Select.computed.readonly
    Select.computed.readonly = function() {
      return oldComputedReadOnly.call(this) && this.allowReadOnly
    }
    /** @param {String} 允许输入框禁用 */
    Select.props.allowReadonly = {
      type: Boolean,
      require: false,
      default: true,
    };
  }
  coverDatePicker(ElementUI.DatePicker);
  coverSelect(ElementUI.Select)
  return ElementUI;
}
